<div class="aeg-billing-details">
    <vl-info-tile tag-name="div" title="Facturatiegegevens">
        <template v-slot:headerextension>
            <vl-button mod-primary icon="pencil" @click="goToBillingDetails" :mod-disabled="errorLoading" mod-icon-after>Aanpassen</vl-button>
        </template>
        <template v-if="loading">
            <div class="aeg-billing-details__loading">
                <vl-loader message="De gegevens worden geladen. Even geduld, a.u.b." />
            </div>
        </template>
        <template v-else-if="errorLoading">
            <div class="aeg-billing-details__error">
                <div class="aeg-billing-details__error-text">
                    <vl-icon icon="warning" mod-error />
                    Er ging iets mis bij het ophalen van uw facturatiegegevens.
                </div>
                <div>
                    <vl-link @click.prevent="loadBillingDetails" mod-icon-before icon="text-redo" mod-block>
                        Opnieuw proberen
                    </vl-link>
                </div>
            </div>
        </template>
        <template v-else>
            <aeg-billing-details :billing-details="billingDetail" />
        </template>
    </vl-info-tile>
</div>